import { render, staticRenderFns } from "./Table_custom.vue?vue&type=template&id=408d5014&scoped=true&"
import script from "./Table_custom.vue?vue&type=script&lang=js&"
export * from "./Table_custom.vue?vue&type=script&lang=js&"
import style0 from "./Table_custom.vue?vue&type=style&index=0&id=408d5014&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d5014",
  null
  
)

export default component.exports